import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import { UploadFile } from '@mui/icons-material';
import { DropWrapper, DropZone } from 'components/dropZone/components';


type DropSheetProps = {
    upload: (file: File) => void;
    title: string;
}

const DropSheet = ({ upload, title }: DropSheetProps) => {
    const { t } = useTranslation();

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDropAccepted: files => {
            const { name } = files[0];
            if (name.endsWith('xlsx') || name.endsWith('xls') || name.endsWith('csv'))
                upload(files[0]);
        },
        multiple: false,
    });

    return (
        <DropWrapper>
            <DropZone {...getRootProps({ className: 'drop-image' })}>
                <input {...getInputProps()} />
                <div className="title"><UploadFile /><br/>{title}</div>
                {isDragActive &&
                    <div className="drop-here">{t('drop_files_here')}...</div>
                }
            </DropZone>
        </DropWrapper>
    )
}

export default DropSheet;
